import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/axios';
import useProjectStore from '../stores/projectStore';

export function useProjects() {
  return useQuery({
    queryKey: ['projects'],
    queryFn: async () => {
      const { data } = await api.get('/projects', { skipProject: true });
      return data;
    },
  });
}

export function useCreateProject() {
  const qc = useQueryClient();
  const addProject = useProjectStore((s) => s.addProject);
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await api.post('/projects', payload, { skipProject: true });
      return data;
    },
    onSuccess: (project) => {
      addProject(project);
      qc.invalidateQueries({ queryKey: ['projects'] });
    },
  });
}

export function useUpdateProject() {
  const qc = useQueryClient();
  const updateProject = useProjectStore((s) => s.updateProject);
  return useMutation({
    mutationFn: async ({ id, ...payload }) => {
      const { data } = await api.patch(`/projects/${id}`, payload, { skipProject: true });
      return data;
    },
    onSuccess: (project) => {
      updateProject(project);
      qc.invalidateQueries({ queryKey: ['projects'] });
    },
  });
}

export function useDeleteProject() {
  const qc = useQueryClient();
  const removeProject = useProjectStore((s) => s.removeProject);
  return useMutation({
    mutationFn: (id) => api.delete(`/projects/${id}`, { skipProject: true }),
    onSuccess: (_, id) => {
      removeProject(id);
      qc.invalidateQueries({ queryKey: ['projects'] });
    },
  });
}

export function useSetDefaultProject() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.post(`/projects/${id}/set-default`, {}, { skipProject: true }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['projects'] }),
  });
}
